export const round = (value: number, decimals: number) =>
    Number(Math.round(value + ('e' as any) + decimals) + 'e-' + decimals).toFixed(decimals);

export const putThousandsSeparators = (value: number | string, sep?: string) => {
    let transformedValue = null;

    if (sep == null) {
        sep = '.';
    }

    // check if it needs formatting
    if (value.toString() === value.toLocaleString()) {
        // split decimals
        const parts = value.toString().split(',');

        // format whole numbers
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);

        // put them back together
        transformedValue = parts[1] ? parts.join(',') : parts[0];
    } else {
        transformedValue = value.toLocaleString();
    }

    return transformedValue;
};

export const toCurrency = (value: number, decimals = 2) => {
    let transformedValue = null;

    transformedValue = round(Number(value), decimals);
    transformedValue = `${value.toString().replace('.', ',')}`;
    transformedValue = putThousandsSeparators(value);

    return `€ ${transformedValue}`;
};
